import { getName, getLink } from 'peach/helpers'

import { R } from 'core/helpers'
import { useInternalBorrowerSearchPaged } from 'core/types'
import { InternalBorrowerSearchVariables } from 'core/types/operations'

type UseBorrowerAppSearchProps = {
  query?: InternalBorrowerSearchVariables['query']
  options?: { [key: string]: unknown }
  companyId?: string
}

const useBorrowerAppSearch = ({
  query,
  options,
  companyId,
}: UseBorrowerAppSearchProps) => {
  const borrowerQuery = useInternalBorrowerSearchPaged({
    companyId,
    options: { enabled: !!companyId, ...(options ?? {}) },
    query,
  })

  const { data: people } = borrowerQuery

  const results = R.map(people ?? [], (person) => ({
    group: 'Borrowers',
    label: getName(person),
    to: getLink(person),
    subtitle: 'Borrower',
    id: person.id,
  }))

  return { ...borrowerQuery, options: results }
}

export default useBorrowerAppSearch
